import { render, staticRenderFns } from "./ResellerAcceptPage.vue?vue&type=template&id=b4c1cf16&"
import script from "./ResellerAcceptPage.vue?vue&type=script&lang=js&"
export * from "./ResellerAcceptPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports